import Component from './Update.vue';

export default {
  install(Vue) {
    Vue.component('BkfDialogEntityUpdate', Component);
  },
};
